import { cn } from '@/lib/cn';

const TONE: Record<string, string> = {
  active: 'bg-mb-success-soft text-mb-success-press',
  running: 'bg-mb-success-soft text-mb-success-press',
  sent: 'bg-mb-success-soft text-mb-success-press',
  draft: 'bg-mb-surface text-mb-text-muted',
  pending: 'bg-mb-surface text-mb-text-muted',
  queued: 'bg-mb-surface text-mb-text-muted',
  paused: 'bg-mb-warning-soft text-mb-warning',
  scheduled: 'bg-mb-accent-soft text-mb-accent-press',
  interested: 'bg-mb-accent-soft text-mb-accent-press',
  meeting_booked: 'bg-mb-accent-soft text-mb-accent-press',
  won: 'bg-mb-success-soft text-mb-success-press',
  failed: 'bg-mb-danger-soft text-mb-danger',
  bounced: 'bg-mb-danger-soft text-mb-danger',
  unsubscribed: 'bg-mb-danger-soft text-mb-danger',
  lost: 'bg-mb-surface text-mb-text-muted',
};

export function StatusPill({ status }: { status: string }): JSX.Element {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-pill px-2 py-0.5 text-xs font-medium capitalize',
        TONE[status] ?? 'bg-mb-surface text-mb-text-muted',
      )}
    >
      {status.replace(/_/g, ' ')}
    </span>
  );
}
